<div class="modal-container">
  <div class="modal-header">
    <div class="modal-header-title">{{options.title}}</div>
    <div class="modal-header-close" *ngIf="options.showCross??true" (click)="cancel('Cross click')"><span class="far fa-times"></span></div>
  </div>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="currentTemplate"></ng-container>
  </div>
  <div class="modal-footer" *ngIf="(options.showSave??true)||(options.showCancel??true)" >
    <button class="btn btn-primary" *ngIf="options.showSave??true" (click)="save()" >{{options.saveText??'Save'}}</button>
    <button class="btn btn-primary2" *ngIf="options.showCancel??true" ngbAutofocus (click)="cancel('Cancel button')">{{options.cancelText??'Cancel'}}</button>
  </div>

</div>
